// Display labels for the ISO 639-1 codes returned by
// `GET /api/translations/languages`. Kept in one place so every language
// selector across the app renders identical labels.
export const LANGUAGE_NAMES = {
    en: 'English',
    da: 'Dansk',
    de: 'Deutsch',
    fr: 'Français',
    es: 'Español',
    nl: 'Nederlands',
    sv: 'Svenska',
    no: 'Norsk',
};
